
<template>
    <div>
        <md-card class="card_full_screen">
            <md-card-content>
                <ValidationObserver ref="valObserver">
                    <form>
                        <FadeTransition :duration="400" mode="out-in" v-if="!loading">
                            <div class="md-layout md-alignment-top-left">

                                <div class="md-layout-item md-size-100 md-small-size-100 md-medium-size-100 md-xlarge-size-100">
                                    <div class="title_with_btns">
                                        <div class="titles">
                                            <h3 class="zero_b_margin">{{website.name}}</h3>
                                            <p class="vertically_tight">{{website.address}}</p>
                                        </div>
                                        <website-menu></website-menu>
                                        <div class="btns">
                                            <div class="btns_sxs">
                                                <md-button class="md-primary" @click="save" title="Attempt to save all changes">Save All</md-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="md-layout-item md-size-60">
                                    <building-visitor-process :visitorProcess="website.visitorProcess" :isAdmin="true"></building-visitor-process>
                                </div>

                                <div class="md-layout-item md-size-40">

                                    <h3>Icons</h3>

                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-25 md-form-label">
                                            Opening Hours Icon
                                        </label>
                                        <div class="md-layout-item md-size-60">
                                            <md-field>
                                                <md-input type="text" v-model="website.visitorProcess.openingHoursIcon" />
                                                fad fa-alarm-clock
                                            </md-field>
                                             <div class="circle_icon">
                                                    <circle-icon :icon="website.visitorProcess.openingHoursIcon" :name="openingHoursTitle" :text="website.visitorProcess.openingHoursText"></circle-icon>
                                                </div>
                                        </div>
                                    </div>

                                    <zoom-center-transition :duration="1000" v-show="website.visitorProcess.reception === true">
                                        <div class="md-layout md-gutter">
                                            <label class="md-layout-item md-size-25 md-form-label">
                                                Reception Icon
                                            </label>
                                            <div class="md-layout-item md-size-60">
                                                <md-field>
                                                    <md-input type="text" v-model="website.visitorProcess.receptionIcon" />
                                                    fad fa-user-clock
                                                </md-field>
                                                <div class="circle_icon">
                                                    <circle-icon :icon="website.visitorProcess.receptionIcon" name="Reception Hours" :text="website.visitorProcess.receptionText"></circle-icon>
                                                </div>
                                            </div>
                                        </div>
                                    </zoom-center-transition>

                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-25 md-form-label">
                                            Entry Icon
                                        </label>
                                        <div class="md-layout-item md-size-60">
                                            <md-field>
                                                <md-input type="text" v-model="website.visitorProcess.entryIcon" />
                                                fad fa-phone-office
                                                <!-- //TODO:TD as we build up icons we reuse, can make these all dlls -->
                                            </md-field>
                                               <div class="circle_icon">
                                                    <circle-icon :icon="website.visitorProcess.entryIcon" name="Entry" :text="website.visitorProcess.entryText"></circle-icon>
                                                </div>
                                        </div>
                                    </div>

                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-25 md-form-label">
                                            Arrival Icon
                                        </label>
                                        <div class="md-layout-item md-size-60">
                                            <md-field>
                                                <md-input type="text" v-model="website.visitorProcess.arrivalIcon" />
                                                fad fa-pen-fancy
                                            </md-field>
                                              <div class="circle_icon">
                                                    <circle-icon :icon="website.visitorProcess.arrivalIcon" name="Arrival" :text="website.visitorProcess.arrivalText"></circle-icon>
                                                </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </FadeTransition>
                        <div class="loader_wrap" v-if="loading">
                            <loader></loader>
                        </div>
                    </form>
                </ValidationObserver>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
    import { FadeTransition, ZoomCenterTransition } from "vue2-transitions";
    import Loader from "@/components/Loader.vue";

    import Help from "@/ts/Help";
    import NotyTypes from "@/ts/NotyTypes";
    import Api from '@/ts/UvApiService';

    import BuildingVisitorProcess from "@/pages/Dashboard/Buildings/VisitorProcess.vue";
    import CircleIcon from "./CircleIcon.vue";
    import WebsiteMenu from "./WebsiteMenu.vue";

    export default {
        components: {
            Loader
            , FadeTransition
            , ZoomCenterTransition
            , BuildingVisitorProcess
            , CircleIcon
            , WebsiteMenu
        },
        data() {
            return {
                loading: true,
                website: null,
            }
        },
        computed: {
            openingHoursTitle() {
                return this.website.visitorProcess.openingHours24 ? "24 Hour Access" : "Opening Hours";
            }
        },
        methods: {
            async fetchData() {
                if (!Help.isNullOrUndef(this.$route.params.buildingId)) {
                    if (Help.isNullOrUndef(this.website)) {
                        var res = await Api.websites.getWebsiteVisitorProcess(this.$route.params.buildingId);
                        this.website = res;
                    }
                    this.loading = false;
                }
            },
             async save() {
                this.$refs.valObserver.validate().then(async success => {
                        if (!success) {
                            setTimeout(() => { 
                                this.notifyErrors(Object.values(this.$refs.valObserver.errors));
                            }, 100);
                            return;
                        }
                        else {
                            await this.saveRaw();
                            //this.$router.push(this.nextUrl);
                        }
                });
            },
            async saveRaw() {
                var res = await Api.websites.upsertVisitorProcess(this.website);
                if (res.success === true) {
                    alert("that worked");
                }
                else {
                    this.showServerFailMessage(res, "saving all");
                }
            },
             notifyErrors(errorsArray) {
                var errorsLis = "";
                errorsArray.forEach((e) => {
                    if (e.length > 0) { 
                        e.flat().forEach((ei) => {
                            errorsLis += `<li>${Help.removeFullStop(ei)}</li>`;
                        });
                    }
                });
                this.$notify({
                    timeout: 10000,
                    message: `Please <b>fix all errors</b> on the current page <b>to proceed</b><ul>${errorsLis}</ul>`,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            showServerFailMessage(res, action) {
                var msg = res.message ?? `Unknown problem on the server ${action} this building`;
                this.$notify({
                    timeout: 10000,
                    message: msg,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            }
        },
        async mounted() {
            await this.fetchData();
        },

    }
</script>
<style lang="scss">
</style>